var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDownDarkgray6Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "6px",
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Chevron-Down_Gray-6px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Chevron-Down_Gray-6px",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Icon_Chevron-Down_White-6px",
    points: "0 0 3 3 6 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownDarkgray6Px);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Down_Darkgray-6px.3ef0a98651c6d29ca49f91144cd2ca37.svg";
export { ForwardRef as ReactComponent };